import React from "react";
import { View } from "ui/atoms/view";
import {
  Checkbox,
  CheckboxIcon,
  CheckboxIndicator,
  CheckboxLabel,
} from "ui/gluestack/checkbox";
import { CircleIcon } from "ui/gluestack/icon";

interface Props {
  value: string;
  label?: string;
  controlElement?: React.ReactNode;
  className?: string;
}

export function SelectableOptionWithControl({
  value,
  label,
  controlElement,
  className,
}: Props) {
  return (
    <View className="flex-row items-center gap-3">
      <Checkbox value={value} size="sm">
        <CheckboxIndicator className="rounded-full">
          <CheckboxIcon as={CircleIcon} />
        </CheckboxIndicator>
        <CheckboxLabel className={className}>{label}</CheckboxLabel>
      </Checkbox>
      {controlElement}
    </View>
  );
}
